/**
 * A custom directive to handle cell country code changes.
 *
 * TODO: read http://stackoverflow.com/questions/14049480/what-are-the-nuances-of-scope-prototypal-prototypical-inheritance-in-angularjs
 */
App.directive('ngCellCountryFilter', ['cellHelper', 'formHelper', function(cellHelper, formHelper) {
    return {
        require: 'ngModel',
        link: function(scope, elem, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            void 0;
            void 0;
            void 0;

            /**
             * Watch out for change of the country code. This will trigger
             * resetting the cell/phone field.
             */
            elem.on('change', function(evt) {
                scope.$apply(function() {
                    var formName;

                    // set the number placeholder (returns cell number validation bool)
                    cellHelper.resetPhoneField(scope, ngModel, elem, evt);

                    // if validation is now failing, update validity of the
                    // cell field in a hacky way (ewwwww...)
                    if (!cellHelper.validateText(scope, ngModel, elem, evt)) {
                        formHelper.setError(scope, 'cell', 'ngCellFilter', true, true);
                    } else {
                        formHelper.clearError(scope, 'cell');
                    }
                });
            });
        }
    }
}]);
